<template>
  <div
    v-if="rating"
    class="flex min-w-0 items-center gap-1 whitespace-nowrap"
    :class="ROW_CLASSES[size]"
  >
    <Star
      class="h-3.5 w-3.5 shrink-0 fill-current text-teal-700"
      aria-hidden="true"
    />
    <span class="font-bold text-teal-900">{{ rating.value }}</span>
    <span v-if="rating.count" class="text-stone-500">({{ count }})</span>
    <span v-if="rating.sourceLabel" class="truncate text-stone-500">
      · {{ rating.sourceLabel }}
    </span>
  </div>
  <div v-else class="flex">
    <!-- A pill in every layout, as in the design -->
    <span
      class="rounded-full bg-teal-100 px-2 text-caption font-semibold text-teal-700"
    >
      {{ t('product.card.newOnKonfetti') }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { Star } from 'lucide-vue-next'
import type {
  ProductCardPartSize,
  ProductCardRating,
} from '~/utils/productCardMapper'

const { rating, size = 'default' } = defineProps<{
  rating: ProductCardRating | null
  size?: ProductCardPartSize
}>()

const ROW_CLASSES: Record<ProductCardPartSize, string> = {
  default: 'text-caption-large',
  small: 'text-caption',
  responsive: 'text-caption md:text-caption-large',
}

const { t, locale } = useI18n()

const count = computed(() =>
  new Intl.NumberFormat(locale.value).format(rating?.count ?? 0)
)
</script>
